import React, {FC} from 'react';
import styled from 'styled-components';

import {Handler, Renderer} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {IconButton} from '../../../../../libs/shared/ui/src/components/buttons/iconButton';
import {Icon} from '../../../../../libs/shared/ui/src/components/icon/icon';
import {UserThemeConsumer} from '../../../../../libs/shared/ui/src/theme/userThemeConsumer';
import {useUserTheme} from '../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {Skeleton} from '../../../common/skeleton';

/*
 * Props.
 */

interface CrmMappingRowProps {
  isReadOnly?: boolean;
  isDisabled?: boolean;
  isLoading?: boolean;
  isAdmin?: boolean;
  renderSourceField?: Renderer;
  renderFrontField?: Renderer;
  onRemove?: Handler;
}

/*
 * Style.
 */

const StyledIconWrapperDiv = styled.div`
  padding: 7px 8px;
`;

const StyledIcon = styled(Icon)`
  transform: rotate(90deg);
  width: 16px;
  height: 16px;
`;

const StyledDeleteButtonWrapperDiv = styled.div`
  padding: 2px 3px;
`;

const StyledFieldWrapperDiv = styled.div`
  overflow: hidden;
`;

/*
 * Component.
 */

export const CrmMappingRow: FC<CrmMappingRowProps> = (props) => {
  const theme = useUserTheme();
  const {isReadOnly, isDisabled, isLoading, isAdmin, renderSourceField, renderFrontField, onRemove} = props;
  if (isLoading) {
    return renderLoadingState();
  }
  return (
    <>
      {renderSourceField && <StyledFieldWrapperDiv>{renderSourceField()}</StyledFieldWrapperDiv>}
      <StyledIconWrapperDiv>
        <StyledIcon name="arrowUpThickSmall" color={theme.greys.shade70} />
      </StyledIconWrapperDiv>
      {renderFrontField && <StyledFieldWrapperDiv>{renderFrontField()}</StyledFieldWrapperDiv>}
      {maybeRenderDeleteButton(onRemove, isReadOnly, isDisabled || !isAdmin)}
    </>
  );
};

/*
 * Helpers.
 */

function renderLoadingState() {
  return (
    <>
      <Skeleton height="30px" />
      <UserThemeConsumer>
        {(theme) => (
          <StyledIconWrapperDiv>
            <StyledIcon name="arrowUpThickSmall" color={theme.greys.shade70} />
          </StyledIconWrapperDiv>
        )}
      </UserThemeConsumer>
      <Skeleton height="30px" />
      {maybeRenderDeleteButton()}
    </>
  );
}

function maybeRenderDeleteButton(onRemove?: Handler, isReadOnly?: boolean, isDisabled?: boolean) {
  if (isReadOnly || !onRemove) {
    return <div />;
  }
  return (
    <StyledDeleteButtonWrapperDiv>
      <IconButton iconName="closeSmall" label={null} onClick={onRemove} isDisabled={isDisabled} />
    </StyledDeleteButtonWrapperDiv>
  );
}
